import React,{useState, useEffect, useContext} from "react";
import Global from '../../APIConfig';
import { useNavigate,Link } from "react-router-dom";
import AuthUser from "../../AuthUser";
import axios from 'axios';
import { AppContext } from '../../context/AppContext';

function LeftPanel()
{
    let navigate = useNavigate();
    const{headers1,headers2,logout}=AuthUser();
    const[show,SetShow]=useState('close');
    const items = JSON.parse(localStorage.getItem('user'));
    const user_privilage_string = items.user_privilage_array;
    const user_privilage_array = user_privilage_string.split(',').map(Number);
    // const [companyname, setCompanyname] = useState('Consolidix Logistics');
    const [loading, setloading] = useState(false);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [DropdownType, setDropdownType] = useState('');
    const { companyname } = useContext(AppContext);

    const userlogout=()=>{
      logout();
      navigate('/');
    }
    

    return (
        <div className={`sidebar ${show}`}>
          <div className="logo-details">
            <div className="head_icon" onClick={()=>{SetShow(show=='close'?'show':'close')}}>
                <i className="bx bx-menu"></i>
            </div>
            <span className="logo_name">{companyname}</span>
          </div>
          <ul className="nav-links">
            <li className={DropdownType=='dashboard'?`showMenu`:''}>
              <div className="iocn-link">
                <a href="#" onClick={()=>{DropdownType!='dashboard'?setDropdownType('dashboard'):setDropdownType('')}} >
                  <i className="bx bx-grid-alt"></i>
                  <span className="link_name">Dashboard</span>
                <i className="bx bxs-chevron-down arrow"></i>
                </a>
              </div>
              <ul className="sub-menu">
                <li><a className="link_name" href="/Admin-Dash">Dashboard</a></li>
                <li><a href="/Admin-Dash">Master Dashboard</a></li>
                <li><a href="/OperationalDashBoard">Operational Dashboard</a></li>
                <li><a href="/CustomerDashBoard">Customer Dashboard</a></li>
                <li><a href="/FinanceDashBoard">Finance Dashboard</a></li>
                <li><a href="/CmsDashBoard">CMS Dashboard</a></li>
                <li><a href="/SystemSettingDashBoard">System Setting Dashboard</a></li>
              </ul>
            </li>
            {items.usertype =='AD' || items.usertype =='M' || user_privilage_array.includes(1) ?
            <li className={DropdownType=='shipments'?`showMenu`:''}>
              <div className="iocn-link">
                <a href="#" onClick={()=>{DropdownType!='shipments'?setDropdownType('shipments'):setDropdownType('')}}>
                  {/* <i className="bx bx-package"></i> */}
                  <i class="bx bx-truck" />
                  <span className="link_name">Shipments</span>
                <i className="bx bxs-chevron-down arrow"></i>
                </a>
              </div>
              <ul className="sub-menu">
                <li><a className="link_name" href="#">Shipments</a></li>
                <li><a href="/Shipmentlist/All">All Shipments</a></li>
                <li><a href="/Shipmentlist/B">Undelivered Shipments</a></li>
                <li><a href="/Shipmentlist/D">Delivered Shipments</a></li>
                {/* <li><a href="/RateCalulator/Domestic">Rate Calculator</a></li> */}
                {/* <li><a href="shipments.php?status=ndr">Missing Shipments</a></li> */}
                {/* <li><a href="shipments.php?status=ndr">NDR Shipments</a></li> */}
                {/* <li><a href="/Shipmentlist/R">RTO Shipments</a></li> */}
              </ul>
            </li>
            :
            ""
            }
            {items.usertype =='AD' || items.usertype =='M' || user_privilage_array.includes(1) ?
            <li className={DropdownType=='shipmentsb2b'?`showMenu`:''}>
              <div className="iocn-link">
                <a href="#" onClick={()=>{DropdownType!='shipmentsb2b'?setDropdownType('shipmentsb2b'):setDropdownType('')}}>
                  {/* <i className="bx bx-package"></i> */}
                  <i class='bx bxs-truck'></i>
                  <span className="link_name">Shipments B2B</span>
                <i className="bx bxs-chevron-down arrow"></i>
                </a>
              </div>
              <ul className="sub-menu">
                <li><a className="link_name" href="#">Shipment B2B</a></li>
                <li><a href="/Createshipmentb2b">Create Shipment B2B</a></li>
                <li><a href="/Shipmentlistb2b/All">All Shipments</a></li>
                <li><a href="/Shipmentlistb2b/B">Undelivered Shipments</a></li>
                <li><a href="/Shipmentlistb2b/D">Delivered Shipments</a></li>
                {/* <li><a href="/RateCalulator/Domestic">Rate calculator</a></li> */}
              </ul>
            </li>
            :
            ""
            }
            {/* <li className={DropdownType=='rate-calculator'?`showMenu`:''}>
              <div className="iocn-link">
                <a href="#" onClick={()=>{DropdownType!='rate-calculator'?setDropdownType('rate-calculator'):setDropdownType('')}}>
                  <i className="bx bx-calculator"></i>
                  <span className="link_name">Settings</span>
                <i className="bx bxs-chevron-down arrow"></i>
                </a>
              </div>
              <ul className="sub-menu">
                <li><a className="link_name" href="/RateCalulator/Domestic">Rate Calculator</a></li>
                <li><a href="/RateCalulator/Domestic">Rate Calculator</a></li>
              </ul>
            </li> */}
            {items.usertype =='AD' || items.usertype =='M' || user_privilage_array.includes(1) ?
            <li className={DropdownType=='weight-discrepancy'?`showMenu`:''}>
              <div className="iocn-link">
                <a href="#" onClick={()=>{DropdownType!='weight-discrepancy'?setDropdownType('weight-discrepancy'):setDropdownType('')}}>
                  <i className="bx bx-add-to-queue"></i>
                  <span className="link_name">Weight Discrepancy</span>
                <i className="bx bxs-chevron-down arrow"></i>
                </a>
              </div>
              <ul className="sub-menu">
                <li><a className="link_name" href="#">Weight Discrepancy</a></li>
                <li><a href="/Weightdiscrepancy">Upload Shipment</a></li>
                <li><a href="/Weightdiscrepancylist">All Weight List</a></li>
              </ul>
            </li>
            :
            ""
            }
            {items.usertype =='AD' || items.usertype =='M' || user_privilage_array.includes(2) ?
            <li className={DropdownType=='prs'?`showMenu`:''}>
              <div className="iocn-link">
                <a href="#" onClick={()=>{DropdownType!='prs'?setDropdownType('prs'):setDropdownType('')}}>
                  <i className="bx bx-collection"></i>
                  <span className="link_name">PRS </span>
                <i className="bx bxs-chevron-down arrow"></i>
                </a>
              </div>
              <ul className="sub-menu ">
                <li><a className="link_name" href="#">Pickup (PRS) Management</a></li>
                <li><a className="" href="/PickupList/Running">Running PRS</a></li>
                <li><a className="" href="/PickupList/Completed">Completed PRS</a></li>
              </ul>
            </li>
            :
            ""
            }
            {items.usertype =='AD' || items.usertype =='M' || user_privilage_array.includes(3) ?
            <li className={DropdownType=='schedule-prs'?`showMenu`:''}>
              <div className="iocn-link">
                <a href="#" onClick={()=>{DropdownType!='schedule-prs'?setDropdownType('schedule-prs'):setDropdownType('')}}>
                  <i className="bx bx-time"></i>
                  <span className="link_name">Scheduled PRS </span>
                <i className="bx bxs-chevron-down arrow"></i>
                </a>
              </div>
              <ul className="sub-menu ">
                <li><a className="link_name" href="#">Scheduled Pickup Management</a></li>
                <li><a className="" href="/ScheduledPickupList">Genrate Scheduled Pickups</a></li>
                <li><a className="" href="/Generatepickupschedulecustomer">Add Customer Scheduled PRS</a></li>
                {/* <li><a className="" href="/Generatepickupscheduleagent">Scheduled PRS Agent</a></li> */}
                <li><a className="" href="/AllScheduledPickupList">Scheduled PRS List</a></li>
                {/* <li><a className="" href="/ScheduledPickupList/All">Scheduled PRS Agent List</a></li> */}
              </ul>
            </li>
            :
            ""
            }
            {items.usertype =='AD' || items.usertype =='M' || user_privilage_array.includes(4) ?
            <li className={DropdownType=='bagging'?`showMenu`:''}>
              <div className="iocn-link">
                <a href="#" onClick={()=>{DropdownType!='bagging'?setDropdownType('bagging'):setDropdownType('')}}>
                  <i className="bx bx-cuboid"></i>
                  <span className="link_name">Bagging</span>
                <i className="bx bxs-chevron-down arrow"></i>
                </a>
              </div>
              <ul className="sub-menu">
                <li><a className="link_name" href="#">Bag Management</a></li>
                <li><a href="/BagList/Running">Running Bags</a></li>
                <li><a href="/BagList/Completed">Completed Bags</a></li>
              </ul>
            </li>
            :
            ""
            }
            {items.usertype =='AD' || items.usertype =='M' || user_privilage_array.includes(5) ?
            <li className={DropdownType=='bag-manifest'?`showMenu`:''}>
              <div className="iocn-link">
                <a href="#" onClick={()=>{DropdownType!='bag-manifest'?setDropdownType('bag-manifest'):setDropdownType('')}}>
                  <i className="bx bx-cube-alt"></i>
                  <span className="link_name">Bag Manifest</span>
                <i className="bx bxs-chevron-down arrow"></i>
                </a>
              </div>
              <ul className="sub-menu">
                <li><a className="link_name" href="#">Bag Manifest Management</a></li>
                <li><a href="/BagManifestList/Running">Running Manifests</a></li>
                <li><a href="/BagManifestList/Completed">Completed Manifests</a></li>
              </ul>
            </li>
            :
            ""
            }
            {items.usertype =='AD' || items.usertype =='M' || user_privilage_array.includes(6) ?
            <li className={DropdownType=='shipment-manifest'?`showMenu`:''}>
              <div className="iocn-link">
                <a href="#" onClick={()=>{DropdownType!='shipment-manifest'?setDropdownType('shipment-manifest'):setDropdownType('')}}>
                  {/* <i className="bx bx-cube-alt"></i> */}
                  <i className='bx bx-package'></i>
                  <span className="link_name">Shipment Manifest</span>
                <i className="bx bxs-chevron-down arrow"></i>
                </a>
              </div>
              <ul className="sub-menu">
                <li><a className="link_name" href="#">Shipment Manifest Management</a></li>
                <li><a href="/ShipmentManifestList/Running">Running Manifests</a></li>
                <li><a href="/ShipmentManifestList/Completed">Completed Manifests</a></li>
              </ul>
            </li>
            :
            ""
            }
             {items.usertype =='AD' || items.usertype =='M' || user_privilage_array.includes(6) ?
            <li className={DropdownType=='forward-through'?`showMenu`:''}>
              <div className="iocn-link">
                <a href="#" onClick={()=>{DropdownType!='forward-through'?setDropdownType('forward-through'):setDropdownType('')}}>
                  <i className='bx bx-mail-send'></i>
                  <span className="link_name">Forward Through</span>
                <i className="bx bxs-chevron-down arrow"></i>
                </a>
              </div>
              <ul className="sub-menu">
                <li><a className="link_name" href="#">Forward Through Manifest Management</a></li>
                <li><a href="/ForwardShipmentManifestList">List Manifests</a></li>
              </ul>
            </li>
            :
            ""
            } 
            {items.usertype =='AD' || items.usertype =='M' || user_privilage_array.includes(7) ?
            <li className={DropdownType=='drs'?`showMenu`:''}>
              <div className="iocn-link">
                <a href="#" onClick={()=>{DropdownType!='drs'?setDropdownType('drs'):setDropdownType('')}}>
                  <i className="bx bx-run"></i>
                  <span className="link_name">DRS</span>
                <i className="bx bxs-chevron-down arrow"></i>
                </a>
              </div>
              <ul className="sub-menu">
                <li><a className="link_name" href="#">DRS Management</a></li>
                <li><a href="/DrsList/Running">Running DRS</a></li>
                <li><a href="/DrsList/Completed">Completed DRS</a></li>
              </ul>
            </li>
            :
            ""
            }
            {items.usertype =='AD' || items.usertype =='M' || user_privilage_array.includes(8) ?
            <li className={DropdownType=='warehouse-scanner'?`showMenu`:''}>
              <div className="iocn-link">
                <a href="#" onClick={()=>{DropdownType!='warehouse-scanner'?setDropdownType('warehouse-scanner'):setDropdownType('')}}>
                  <i className="bx bx-scan"></i>
                  <span className="link_name">Warehouse Scanner</span>
                <i className="bx bxs-chevron-down arrow"></i>
                </a>
              </div>
              <ul className="sub-menu">
                <li><a className="link_name" href="#">Warehouse Inbound Scanner</a></li>
                <li><a className="" href="/WarehouseScanner/Pickup">Scan Pickup Shpiments</a></li>
                <li><a className="" href="/WarehouseScanner/Manifested_Bag">Scan Bags</a></li>
                <li><a className="" href="/WarehouseScanner/Manifested_Shipment">Scan Manifest Shipments</a></li>
                <li><a className="" href="/WarehouseScanner/Schedule_Pickup">Scan Schedule Pickup</a></li>
                {/* <li><a className="" href="/WarehouseScanner/Delivery">Scan DRS Shipments</a></li> */}
              </ul>
            </li>
            :
            ""
            }
            {items.usertype =='AD' || items.usertype =='M' || user_privilage_array.includes(14) ?
            <li className={DropdownType=='settings'?`showMenu`:''}>
              <div className="iocn-link">
                <a href="#" onClick={()=>{DropdownType!='settings'?setDropdownType('settings'):setDropdownType('')}}>
                  <i className="bx bx-cog"></i>
                  <span className="link_name">Settings</span>
                <i className="bx bxs-chevron-down arrow"></i>
                </a>
              </div>
              <ul className="sub-menu">
                <li><a className="link_name" href="/Settings">Settings</a></li>
                <li><a href="/Settings">Setting</a></li>
                {/* <li><a href=".php">Lable Settings</a></li>
                <li><a href=".php">Developer APIs</a></li> */}
              </ul>
            </li>
            :
            ""
            }

            <li>
            <div className="profile-details">
                <div className="profile-content">
                <img src={`${Global.logoUrl}${items.profile_image}`} alt="profileImg" />
                </div>
                <div className="name-job">
                <div className="profile_name">{items.name}</div>
                <div className="job">{items.company}</div>
                </div>
                <i className="bx bx-log-out" onClick={()=>userlogout()}></i>
            </div>
        </li>
      </ul>
    </div>
    );

}
export default LeftPanel;